export type StudentRosterEntry = {
  studentNumber: string;
  displayName: string;
};

export const STUDENT_ROSTER: StudentRosterEntry[] = [
  { studentNumber: '1', displayName: '白育嘉' },
  { studentNumber: '2', displayName: '曹逸芃' },
  { studentNumber: '3', displayName: '曹致远' },
  { studentNumber: '4', displayName: '陈南羽' },
  { studentNumber: '5', displayName: '方思辰' },
  { studentNumber: '6', displayName: '付静怡' },
  { studentNumber: '7', displayName: '顾铭皓' },
  { studentNumber: '8', displayName: '韩雨澄' },
  { studentNumber: '9', displayName: '黄馨如' },
  { studentNumber: '10', displayName: '黄旭骐' },
  { studentNumber: '11', displayName: '金逸' },
  { studentNumber: '12', displayName: '来济安' },
  { studentNumber: '13', displayName: '来佳妮' },
  { studentNumber: '14', displayName: '来铭萱' },
  { studentNumber: '15', displayName: '来易' },
  { studentNumber: '16', displayName: '来瑀涵' },
  { studentNumber: '17', displayName: '李瑾芮' },
  { studentNumber: '18', displayName: '李曜奇' },
  { studentNumber: '19', displayName: '罗熙玥' },
  { studentNumber: '20', displayName: '阮佳宸' },
  { studentNumber: '21', displayName: '商予曦' },
  { studentNumber: '22', displayName: '石妤曦' },
  { studentNumber: '23', displayName: '施喆成' },
  { studentNumber: '24', displayName: '孙陈垚' },
  { studentNumber: '25', displayName: '孙屹楠' },
  { studentNumber: '26', displayName: '孙艺睿' },
  { studentNumber: '27', displayName: '王梦泽' },
  { studentNumber: '28', displayName: '王绎涵' },
  { studentNumber: '29', displayName: '夏逸钶' },
  { studentNumber: '30', displayName: '徐靖骁' },
  { studentNumber: '31', displayName: '叶铃涵' },
  { studentNumber: '32', displayName: '于莳' },
  { studentNumber: '33', displayName: '俞孙浩' },
  { studentNumber: '34', displayName: '俞奕鑫' },
  { studentNumber: '35', displayName: '张钧洋' },
  { studentNumber: '36', displayName: '张梦羽' },
  { studentNumber: '37', displayName: '张思瑶' },
  { studentNumber: '38', displayName: '张王颖' },
  { studentNumber: '39', displayName: '张馨宁' },
  { studentNumber: '40', displayName: '赵逸航' },
  { studentNumber: '41', displayName: '张喆恩' },
  { studentNumber: '42', displayName: '吴芮熙' },
  { studentNumber: '43', displayName: '刘洋志' },
  { studentNumber: '44', displayName: '田昌祺' },
  { studentNumber: '45', displayName: '吉芸蕊' },
  { studentNumber: '46', displayName: '小晖' },
  { studentNumber: '47', displayName: '小春' },
  { studentNumber: '49', displayName: '小金' },
  { studentNumber: '50', displayName: '小咪' },
];
